import React, { useEffect, useRef, useState } from "react";
import logoSeps from "../assets/logo_seps.png";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Messages } from "primereact/messages";

export const Banner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { mensaje } = location.state || {};
  const msgs = useRef(null);

  useEffect(() => {
    msgs.current?.clear();
    if (mensaje) {
      msgs.current?.show([
        { sticky: true, severity: "warn", summary: "Advertencia", detail: mensaje },
      ]);
    }
  }, [mensaje]);

  const handleLogout = () => {
    sessionStorage.removeItem("userData");
    navigate(location.state?.datos?.redirectTo ?? "/reserva", { replace: true });
  };

  return (
    <>
      <div className="layout-topbar surface-ground p-3 border-bottom-1 surface-border header relative">
        <div className="flex align-items-center justify-content-center">
          <img src={logoSeps} alt="Logo" className="h-4rem" />
        </div>
        {location.state?.datos && (
          <div
            className="absolute"
            style={{ top: "50%", right: "1rem", transform: "translateY(-50%)" }}
          >
            <Button
              tooltip="Cerrar Sesión"
              icon="pi pi-sign-out"
              severity="secondary"
              tooltipOptions={{ position: "left" }}
              onClick={handleLogout}
            />
          </div>
        )}
      </div>
      <Messages ref={msgs} />
    </>
  );
};
